<template>
  <div class="award-user">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
      <el-form-item label="姓名">
        <el-input v-model="dataForm.realName"></el-input>
      </el-form-item>
      <!-- <el-form-item label="工号" v-if="type">
        <el-input v-model="dataForm.jobNumber"></el-input>
      </el-form-item> -->
      <el-form-item label="工种" v-if="type">
        <el-select v-model="dataForm.professionId" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.professionId"
            :label="item.professionName"
            :value="item.professionId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="团队" v-if="type">
        <el-select v-model="dataForm.teamId" placeholder="请选择">
          <el-option
            v-for="item in teamList"
            :key="item.teamId"
            :label="item.teamName"
            :value="item.teamId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="店铺" v-if="type">
        <el-select v-model="dataForm.storeId" placeholder="请选择">
          <el-option
            v-for="item in storeList"
            :key="item.storeId"
            :label="item.storeName"
            :value="item.storeId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域" v-if="type">
        <el-select v-model="dataForm.districtId" placeholder="请选择">
          <el-option
            v-for="item in areaList"
            :key="item.districtId"
            :label="item.districtName"
            :value="item.districtId"
          >
          </el-option>
        </el-select>
      </el-form-item>
       <!-- <el-form-item label="岗位">
        <el-select v-model="dataForm.roleId" placeholder="请选择">
          <el-option label="区域一" value="0"></el-option>
          <el-option label="区域二" value="1"></el-option>
        </el-select>
      </el-form-item>
     <el-form-item label="时间">
        <el-date-picker
          v-model="dataForm.time"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="getDataList(1)">查询</el-button>
        <el-button @click="cleaList()">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-button type="primary" class="addBtn" @click="addOrUpdateHandle()"
      >新增</el-button> -->

    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%;">
      <el-table-column prop="realName" align="center" min-width="150" label="姓名"></el-table-column>
      <el-table-column prop="storeName" align="center" min-width="180" label="所属店铺"></el-table-column>
      <el-table-column prop="districtName" align="center" min-width="180" label="所属区域"></el-table-column>
      <el-table-column prop="bonus" align="center" min-width="180" label="奖金值"></el-table-column>
      <el-table-column prop="roleName" align="center" min-width="180" label="岗位"></el-table-column>
      <el-table-column prop="professionName" align="center" min-width="180" label="工种"></el-table-column>
      <el-table-column prop="remark" align="center" min-width="220" label="备注"></el-table-column>
      <el-table-column align="center" min-width="150" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)">查看</el-button>
          <el-button type="text" size="small" @click="deleteHandle(scope.row.bonusId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <award-edit v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></award-edit>
  </div>
</template>

<script>
import awardEdit from "./comm/awardEdit";
import { professionListData, teamListData, districtList, storeListData } from "@/api/list";
import { bonusList, bonusDelete } from './api';
export default {
  components: {
    awardEdit,
  },
  data() {
    return {
      dataForm: {},
      dataList: [{}],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      teamList: [],
      areaList: [],
      storeList: [],
      typeList: [],
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      type: ''
    };
  },
  mounted() {
    this.getDataList();
    this.getTeamList();
    this.getArea();
    this.getStore();
    this.getTypeList();
  },
  methods: {
    // 获取奖金列表
    getDataList(page) {
      this.dataListLoading = true;
      // 判断组长和公司管理
      if(sessionStorage.getItem('isChairman')  == 'Y'){
        this.type = true;
      }else if(sessionStorage.getItem('isLeader')  == 'Y') {
        this.type = false;
      };
      bonusList({
          page: page || this.pageIndex,
          limit: this.pageSize,
          jobNumber: this.dataForm.jobNumber,
          realName: this.dataForm.realName,
          storeId: this.dataForm.storeId,
          districtId: this.dataForm.districtId,
          teamId: this.dataForm.teamId,
          professionId: this.dataForm.professionId,
        }).then( data => {
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
          this.$message.error(data.msg);
        }
        this.dataListLoading = false;
      });
    },
     // 工种列表
    getTypeList() {
      professionListData({
          page: 1,
          limit: 1000
      }).then( data  => {
        if (data && data.code === 0) {
          this.typeList = data.page.list;
        } else {
          this.typeList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 获取团队列表
    getTeamList() {
      teamListData({
          page: 1,
          limit: 10000,
          storeId: null,
          teamName: null,
          realName: null,
          districtName: null
      }).then( data => {
        if (data && data.code === 0) {
          this.teamList = data.page.list;
        } else {
          this.teamList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 区域列表
    getArea() {
      districtList({
          page: 1,
          limit: 1000
      }).then( data => {
        if (data && data.code === 0) {
          this.areaList = data.page.list;
        } else {
          this.areaList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 店铺列表
    getStore() {
      storeListData({
          page: 1,
          limit: 10000,
          districtId: null
      }).then( data => {
        if (data && data.code === 0) {
          this.storeList = data.page.list;
        } else {
          this.storeList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 重置
    cleaList() {
      this.dataForm = {};
      this.pageIndex = 1;
      this.getDataList();
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(data) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(data);
      });
    },
    // 删除
    deleteHandle(id) {
      var bonusId = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.bonusId;
          });
      this.$confirm(
        `确定进行删除操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          bonusDelete(userIds).then( data => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.getDataList();
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.addBtn {
  margin-bottom: 20px;
}
</style>